/**
 * @flow
 * */
import type { ActivityLogFilterParams } from 'modules/Admin/ActivityLog/core/sdk/types';

import ACTIONS from './types';

// Activity Log Table
export const fetchActivityLogs = (filters: ActivityLogFilterParams) => ({
  type: ACTIONS.FETCH_ACTIVITY_LOGS,
  payload: { filters }
});
export const setFetchActivityLogsSuccess = ({ data, totalCount, passTotalCount }: Object) => ({
  type: ACTIONS.SET_FETCH_ACTIVITY_LOGS_SUCCESS,
  payload: { data, totalCount, passTotalCount }
});
export const setFetchActivityLogsFailure = (error: string) => ({
  type: ACTIONS.SET_FETCH_ACTIVITY_LOGS_FAILURE,
  payload: { error }
});
export const clearActivityLogsState = () => ({
  type: ACTIONS.CLEAR_ACTIVITY_LOGS_STATE
});

// cancel call
export const cancelActivityLogSDKCalls = ({ name }: { name: string | Array<string> }) => ({
  type: ACTIONS.CANCEL_ACTIVITY_LOG_SDK_CALL,
  payload: { name }
});
